import React from 'react'

export const Accordion=({className,children})=>{
    return <div className={`accordion ${className}`}>
        {children}
    </div>
}
